import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const certs = [
  { key: 'cert_1', icon: 'ri-award-line' },
  { key: 'cert_2', icon: 'ri-vip-crown-line' },
  { key: 'cert_3', icon: 'ri-building-line' },
  { key: 'cert_4', icon: 'ri-shield-check-line' },
  { key: 'cert_5', icon: 'ri-file-shield-line' },
  { key: 'cert_6', icon: 'ri-user-follow-line' },
];

export default function Certifications() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="certifications" className="bg-slate-primary py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className={`text-center mb-8 md:mb-10 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-manrope font-bold text-white text-xl md:text-2xl lg:text-3xl">
            {t('certifications_h2')}
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {certs.map((cert, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-2.5 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-full transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 100 + 200}ms` }}
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-copper/20">
                <i className={`${cert.icon} text-copper`} />
              </div>
              <span className="text-white text-sm font-medium whitespace-nowrap">{t(cert.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}